import React from 'react';
import { Button } from '@mui/material';
export var KeyboardButton = function (_a) {
    var label = _a.label, onClick = _a.onClick, margin = _a.margin, width = _a.width, size = _a.size, color = _a.color, disabled = _a.disabled, fullWidth = _a.fullWidth, variant = _a.variant, startIcon = _a.startIcon, children = _a.children;
    return (React.createElement(Button, { variant: variant, color: color, onClick: onClick, size: size, disabled: disabled, fullWidth: fullWidth, startIcon: startIcon, sx: { m: { margin: margin }, width: { width: width }, textTransform: 'none' } },
        label,
        children));
};
//# sourceMappingURL=KeyboardButton.js.map